import React from "react";
import Layout from "../Layout";
import {
  Grid,
  makeStyles,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  IconButton,
} from "@material-ui/core";
import {
  Info,
} from '@material-ui/icons/';
import { withRouter } from "react-router";
import useApi from "Hooks/Upload/useApi";
import useAuth from "Hooks/Upload/useAuth";

import "dayjs/locale/ja";
import dayjs from "dayjs";
dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    // overflow: "auto",
    flexDirection: "column",
  },
  wrapper: {
    marginTop: theme.spacing(2),
  },
  accountInfo: {
    display: "inline-box",
    width: "120px",
  },
  table: {
    // width: "1600px",
    overflowX: "auto",
  },
  nthOfTypeOddRow: {
    backgroundColor: "#eee",
  },
  infoIconCell: {
    textAlign: "center",
    width: "110px",
  },
  infoIcon: {
    textAlign: "center",
    color: "#556cd6",
  },
}));

function Groups(props) {
  const { params } = props.match;
  const accountId = parseInt(params.accountId, 10);

  const { request } = useApi();
  const auth = useAuth();
  const classes = useStyles();

  const [account, setAccount] = React.useState({});
  const [groups, setGroups] = React.useState([]);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Upload - アカウント詳細";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchAccount();
    fetchGroups();
  }, [auth.state.token]);

  const fetchAccount = () => {
    request({
      method: "GET",
      url: `media/upload/accounts/${accountId}`,
    }).then((result) => {
      setAccount(result.data.data);
    });
  };

  const fetchGroups = () => {
    request({
      method: "GET",
      url: `media/upload/groups/${accountId}`,
    }).then((result) => {
      setGroups(result.data.data);
    });
  };

  const onClickInfoButton = (id) => {
    props.history.push(`/upload/top/group/${accountId}/info/${id}`);
  };

  function Row(props) {
    const { row, index } = props;
    const isNthOfTypeOdd = index % 2 === 0 ? false : true ;
  
    return (
      <React.Fragment>
        <TableRow className={isNthOfTypeOdd ? classes.nthOfTypeOddRow : null}>
          <TableCell>{row.id}</TableCell>
          <TableCell>{row.name}</TableCell>
          <TableCell>{row.desc}</TableCell>
          <TableCell className={classes.infoIcon}>
          <IconButton 
              color="primary" 
              aria-label="add an Info"
              onClick={() => onClickInfoButton(row.id)}
            >
              <Info />
            </IconButton>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  return (
    <Layout
      content={
        <>
          <Grid>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                アカウント詳細
              </Typography>
              <Grid container>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    アカウントID
                  </Typography>
                  <Typography variant="inherit" >
                    {account.id}
                  </Typography>
                </Grid>
                <Grid item xs={12} className={classes.wrapper}>
                  <Typography variant="inherit" className={classes.accountInfo}>
                    アカウント名
                  </Typography>
                  <Typography variant="inherit" >
                    {account.name}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
            <Paper elevation={3} className={classes.paper}>
              <Typography variant="h6" color="primary">
                収集グループ一覧
              </Typography>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>収集グループID</TableCell>
                    <TableCell>収集グループ名</TableCell>
                    <TableCell>概要</TableCell>
                    <TableCell className={classes.infoIconCell}>詳細</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {groups.map(
                    function (row, index) {
                      return <Row index={index+1} row={row} />
                    }
                  )}
                </TableBody>
              </Table>
            </Paper>
          </Grid>
        </>
      }
    />
  );
}

export default withRouter(Groups);
